var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"Avatar",style:(_vm.style)},[(_vm.src)?_c('img',{attrs:{"src":_vm.Img(_vm.src)}}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }